import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// native components
import AdvisorConnectCardSimplified from '../../../../components/advisorConnectCardSimplified';

export default () => {
  return (
    <AdvisorConnectCardSimplified
      id='investment-account-protection'
      advisorImageVariant='advisorB'
      headingText={<>Get your <WidowBlock>questions answered</WidowBlock></>}
      text='Our financial advisors know what risks to watch out for, so they can build a plan to help grow your wealth and protect it.'
      subText=''
      linkText='Connect with an advisor'
    />
  );
};
